module.exports = __webpack_public_path__ + "static/media/toggl-active.24c91aff.svg";